export const FAVORITE_ACTIVITIES_PROTRACK_LEVEL_FILTER_DEFAULT_ID = 'default'
export const FAVORITE_ACTIVITIES_PROTRACK_LEVEL_FILTER_DEFAULT_VALUE = 'All ProTracks'
export const NO_ACTIVITIES_PROPS = {
  topText: 'You do not have any favorite activities in this ProTrack',
  bottomText:
    'Once you finish an activity, you can click on the heart button in your dashboard to add that activity to your favorites',
  imageSrc: 'users/02b90d67-3206-4108-838f-301f4c9c4585.png',
}
